import ProMember from './ProMember';
import ManufacturerPartnerMember from './ManufacturerPartnerMember';
import NoResultsPanel from './NoResultsPanel';
import {useTranslation} from "react-i18next";

export default function ProPanel(props) {
    const {t, i18n} = useTranslation();
    return (
        <div className="individuals form__individuals">
            <h6>{t('Directory.ProPanel')}</h6>
            <div className="individuals__items">
                {props.hits.map((hit) => {
                    if (hit.directory_user_type === 'Individuals' || hit.directory_user_type === 'Companies') {
                        return <ProMember hit={hit}/>
                    }
                    if (hit.directory_user_type === 'Manufacturers Suppliers') {
                        return <ManufacturerPartnerMember hit={hit}/>
                    }
                    if (Array.isArray(hit.directory_user_type)) {
                        if (['Individuals', 'Companies'].some(v => hit.directory_user_type.includes(v))) {
                            return <ProMember hit={hit}/>
                        }
                    }
                })}
                {props.hits.length === 0 && <NoResultsPanel/>}
            </div>
        </div>
    )
}
